import usePlayerDispatch from '../providers/player-providers/use-player-dispatch';
import useVideoContext from '../providers/video-providers/use-video-context';

export default function useResourceNavigation() {
  const dispatch = usePlayerDispatch();
  const { duration, getProgress } = useVideoContext();

  const handleNext = () => {
    dispatch({
      type: 'SET_NEXT_RESOURCE',
      payload: {
        duration,
        progress: getProgress(),
      },
    });
  };

  const handlePrev = () => {
    dispatch({
      type: 'SET_PREVIOUS_RESOURCE',
      payload: {
        duration,
        progress: getProgress(),
      },
    });
  };

  return {
    handleNext,
    handlePrev,
  };
}
